export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/[0.06]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <div className="flex items-end gap-4">
              <img
                src="/NaN-Logotype-05-300x169.png"
                alt="NaN Studio"
                width="300"
                height="169"
                className="h-20 md:h-28 w-auto"
              />
            </div>
            <div className="mt-6 font-display font-black uppercase tracking-tighter text-4xl md:text-6xl leading-none">
              NaN <span className="text-[#29ABE2]">Studio</span>
            </div>
            <p className="mt-8 max-w-md text-white/55 text-sm leading-relaxed">
              Engineering digital reality. Apps, platforms, AI systems and
              custom software for founders who refuse to look like everyone else.
            </p>
          </div>

          <div className="md:col-span-2 md:col-start-8">
            <div className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">
              Studio
            </div>
            <ul className="space-y-2 text-sm">
              <li><a href="#services" className="text-white/75 hover:text-white">Services</a></li>
              <li><a href="#work" className="text-white/75 hover:text-white">Work</a></li>
              <li><a href="#process" className="text-white/75 hover:text-white">Process</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">
              Contact
            </div>
            <ul className="space-y-2 text-sm">
              <li><a href="mailto:contact@nanstudio.al" className="text-white/75 hover:text-white">contact@nanstudio.al</a></li>
              <li><a href="tel:+355686081818" className="text-white/75 hover:text-white">+355 68 60 81818</a></li>
              <li className="text-white/55">Tirana · Remote</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">
              Social
            </div>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="https://www.linkedin.com/company/nanstudio/" target="_blank" rel="noopener noreferrer" className="text-white/75 hover:text-white">
                  LinkedIn ↗
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/nanstudio.al/" target="_blank" rel="noopener noreferrer" className="text-white/75 hover:text-white">
                  Instagram ↗
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/[0.06] flex flex-col md:flex-row md:items-center justify-between gap-4 font-mono-accent text-[10px] uppercase tracking-[0.3em] text-white/40">
          <div>© {year} NaN Studio · All rights, all wrongs reserved</div>
          <div className="flex items-center gap-6">
            <span className="inline-flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
              Accepting projects · Q2
            </span>
            <span>v.2.0</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
